import { useSelector } from 'react-redux';

const useResonanceLoadingState = (key) => {
  const isProjectLoading = useSelector((state) => state.resonance.isProjectLoading);

  const isLoading = useSelector((state) => state.resonance[key]);

  return isProjectLoading || isLoading;
};
export default useResonanceLoadingState;
